document.addEventListener('DOMContentLoaded', function() {
  let isUpdating = false;

  function initializeBundleScript() {
    const quantityInput = document.getElementById('quantity');
    const productQuantitySelector = document.querySelector('.product-quantity__selector');
    
    if (!quantityInput) {
      console.log('Quantity input not found, retrying...');
      setTimeout(initializeBundleScript, 100);
      return;
    }

    // Remove existing event listeners to prevent duplicates
    const quantityIcons = document.querySelectorAll('.quantity-icon');
    const radioButtons = document.querySelectorAll('.v-bundle-input');
    const bundleItems = document.querySelectorAll('.v-bundle-item');

    quantityIcons.forEach(icon => {
      icon.removeEventListener('click', handleQuantityIconClick);
      icon.addEventListener('click', handleQuantityIconClick);
    });
    
    radioButtons.forEach(radio => {
      radio.removeEventListener('click', handleRadioButtonClick);
      radio.addEventListener('click', handleRadioButtonClick);
    });

    function handleQuantityIconClick(event) {
      if (isUpdating) return;
      
      const isPlus = event.target.id === 'plus';
      const currentValue = parseInt(quantityInput.value) || 1;
      quantityInput.value = isPlus ? currentValue + 1 : Math.max(currentValue - 1, 1);
      updateBundleState();
    }

    function handleRadioButtonClick(event) {
      if (isUpdating) return;
      
      const clickedRadio = event.target;
      const clickedValue = parseInt(clickedRadio.value);
      
      // Clear all radio buttons first
      document.querySelectorAll('.v-bundle-input').forEach(radio => radio.checked = false);
      clickedRadio.checked = true;
      quantityInput.value = clickedValue;
      
      updateBundleState();
      toggleElementsBasedOnQuantity(clickedValue);
    }

    function updateBundleState() {
      if (isUpdating) return;
      isUpdating = true;
      
      setTimeout(() => {
        updateRadioButtons();
        updateCheckedStatus();
        updateProductQuantitySelectorValue();
        isUpdating = false;
      }, 10);
    }

    function updateRadioButtons() {
      const currentValue = parseInt(quantityInput.value) || 1;
      const radioButtons = document.querySelectorAll('.v-bundle-input');
      
      radioButtons.forEach(radio => {
        const radioValue = parseInt(radio.value);
        radio.checked = currentValue >= radioValue;
      });
    }

    function updateCheckedStatus() {
      const bundleItems = document.querySelectorAll('.v-bundle-item');
      
      bundleItems.forEach(item => {
        const radioInput = item.querySelector('.v-bundle-input');
        const optionRadio = item.querySelector('.option-radio');

        if (radioInput && radioInput.checked) {
          item.classList.add('checked');
          if (optionRadio) optionRadio.classList.add('checked');
        } else {
          item.classList.remove('checked');
          if (optionRadio) optionRadio.classList.remove('checked');
        }
      });
    }

    function updateProductQuantitySelectorValue() {
      const productQuantitySelector = document.querySelector('.product-quantity__selector');
      if (productQuantitySelector) {
        productQuantitySelector.value = quantityInput.value;
      }
    }

    function toggleElementsBasedOnQuantity(quantity) {
      const pPriceCardElement = document.getElementById('p-price-card');
      const pDiscountElement = document.getElementById('p-info-note');
      const differenceElement = document.getElementById('difference');

      if (quantity >= 7) {
        if (differenceElement) differenceElement.style.opacity = '1';
        if (pDiscountElement) pDiscountElement.style.display = 'none';
        if (pPriceCardElement) pPriceCardElement.style.opacity = 1;
      } else if (quantity >= 5) {
        if (differenceElement) differenceElement.style.opacity = '1';
        if (pDiscountElement) pDiscountElement.style.display = 'none';
        if (pPriceCardElement) pPriceCardElement.style.opacity = 1;
      } else if (quantity >= 3) {
        if (differenceElement) differenceElement.style.opacity = '1';
        if (pDiscountElement) pDiscountElement.style.display = 'none';
        if (pPriceCardElement) pPriceCardElement.style.opacity = 1;
      } else {
        if (differenceElement) differenceElement.style.opacity = '0';
        if (pDiscountElement) pDiscountElement.style.display = 'block';
        if (pPriceCardElement) pPriceCardElement.style.opacity = 0;
      }
    }

    // Initial setup
    const initialQuantity = parseInt(quantityInput.value) || 1;
    updateBundleState();
    toggleElementsBasedOnQuantity(initialQuantity);
    
    console.log('Bundle script initialized with quantity:', initialQuantity);
  }

  // Handle variant changes with event delegation
  document.addEventListener('change', function(event) {
    if (event.target.classList.contains('product-variant__input')) {
      console.log('Variant changed, reinitializing bundle script...');
      
      setTimeout(() => {
        initializeBundleScript();
      }, 200);
    }
  });

  // Initial initialization
  initializeBundleScript();
});